const strToSlug = (str) => {
	str = str.split('?').join(' ').split('¿').join(' ').split('.').join(' ');
	str = str.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
	return str.split('/').join('-').split(' ').map( part => part.toLowerCase() ).join('-');
}

const capitalize = ( str ) => {
	if(str === 'GanAhorro'){
		return str;
	}
	var slug = strToSlug(str);
	var cap = slug.split('-').map( part => part.length > 0 ? part[0].toUpperCase() + part.substr(1) : part ).join('').trim();
	return cap;
}

const utilGtm = (gtm, slug) => {
	if(typeof gtm !== 'string' || typeof slug !== 'string'){
		return '';
	}
	slug = slug.split('?')[0];

	var cap = capitalize(slug);

	return ` ${ gtm.trim() }${ cap }`;
}

const eventPushGTM = (categoria, accion, etiqueta) => {
	pushDataLayer({
		event: "pushEventGA",
		categoria: categoria,
		accion: accion,
		etiqueta: etiqueta,
	});
}

const pushDataLayer = (data) => {
	//console.log(data); 
	if( window && window.dataLayer ){		
		window.dataLayer.push( data );
	}
}
const pushGtag = (data) => {
	if(typeof gtag === 'function'){
		gtag('event', 'purchase', data);
	}
}

module.exports = {
	utilGtm,
	strToSlug,
	capitalize,
	eventPushGTM,
	pushDataLayer,
	pushGtag,
}